// @section 1 Command module — parent shell + nested sub-route routing.
// Adam's interim personal cockpit (2026-06-18) while annual-planning logic is
// worked out ahead of My Day. Merges the former Daily Ops Review + Ops Pulse +
// Initiatives pages into ONE module with sub-tabs, sitting first in the nav
// (above My Day). Each tab renders its existing page component with embedded
// (the page drops its own breadcrumb/title so this shell owns the chrome).

import { NavLink, Route, Routes } from 'react-router-dom';
import { useIsMobile } from '../../lib/useIsMobile';
import Today from './Today';
import Clients from './Clients';
import OpsPulse from '../OpsPulse';
import Initiatives from '../Initiatives';

// @subsection 1.1 Tab registry (URL-driven, same pattern as the Campaigns shell)
const TABS: { to: string; label: string; end?: boolean }[] = [
  { to: '/command', label: 'Today', end: true },
  { to: '/command/clients', label: 'Clients' },
  { to: '/command/initiatives', label: 'Initiatives' },
  { to: '/command/pulse', label: 'Pulse' },
];

// @subsection 1.2 Header + tab strip
function CommandTabs() {
  const isMobile = useIsMobile();
  return (
    <div style={{ flexShrink: 0, borderBottom: '1px solid var(--t2-border)', background: 'rgba(10,19,34,0.35)' }}>
      <div style={{ padding: isMobile ? '10px 12px 0' : '12px 26px 0' }}>
        <div className="text-[10px] uppercase tracking-[2px] text-muted font-semibold mb-1">Atlas / Command</div>
      </div>
      {/* @block 1.2.1 NavLink tab strip with active underline */}
      <div style={{
        display: 'flex', gap: 4, padding: isMobile ? '0 12px' : '0 26px',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
      }}>
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            style={({ isActive }) => ({
              padding: '7px 12px',
              fontSize: 12,
              fontWeight: 600,
              color: isActive ? 'var(--tx-0)' : 'var(--tx-3)',
              textDecoration: 'none',
              borderBottom: isActive ? '2px solid var(--brand-3)' : '2px solid transparent',
              marginBottom: -1,
            })}
          >
            {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}

// @section 2 Module shell
export default function Command() {
  return (
    <div style={{ display: 'grid', gridTemplateRows: 'auto 1fr', height: '100%', minHeight: 0 }}>
      <CommandTabs />
      <div style={{ minHeight: 0, overflow: 'auto', padding: '18px 26px' }}>
        <Routes>
          <Route index element={<Today />} />
          <Route path="clients" element={<Clients />} />
          <Route path="pulse" element={<OpsPulse embedded />} />
          <Route path="initiatives" element={<Initiatives embedded />} />
        </Routes>
      </div>
    </div>
  );
}
